import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { SnackbarService } from '../../store/services/snackbar.service';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private snackBar: SnackbarService) {}

    get getIcon() {
        switch (this.data.snackType) {
            case 'success':
                return '#check-in-circle';
            case 'error':
                return '#circle-close';
            case 'warning':
                return '#warning';
            default:
                return '#warning';
        }
    }

    closeSnackBar() {
        this.snackBar.closeSnackBar();
    }
}
